<template>
  <div class="ma-0 mx-auto" style="min-height: 100%; max-width: 1000px;">
    <v-card style="max-width: 700px;" class="mx-auto py-2 poll-card poll-card-centered" elevation="6">
      <h2 class="mb-5">{{ poll?.title || 'Poll' }}</h2>
      <v-card-subtitle class="poll-card-subtitle-centered">{{ formatDate(poll?.start_time) }} - {{
        formatDate(poll?.end_time) }}</v-card-subtitle>
      <v-card-text class="poll-card-text-centered">
        <div class="mb-2 poll-card-desc-centered">{{ poll?.description }}</div>
        <div class="candidates-list poll-card-candidates-centered">
          <v-radio-group v-model="selectedCandidate" :disabled="hasVoted" column>
            <v-radio v-for="candidate in poll?.candidates || []" :key="candidate.candidate_id" :label="candidate.name"
              :value="candidate.candidate_id" class="candidate-radio" />
          </v-radio-group>
        </div>
        <div v-if="hasVoted" class="mt-2">
          <v-chip color="success" label>Your Vote: {{ getCandidateName(poll, userVote) }}</v-chip>
        </div>
      </v-card-text>
      <v-card-actions class="poll-card-actions-centered">
        <v-btn color="secondary" :disabled="hasVoted || !selectedCandidate" @click="submitVote">Vote</v-btn>
        <v-btn text @click="$router.push('/dashboard/member/polls')">Back to Polls</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
export default {
  name: 'Poll',

  props: {
    polls: {
      type: Array,
      required: true,
    },
    userInfo: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      poll: null,
      selectedCandidate: null,
      submitting: false,
    };
  },

  computed: {
    userVote() {
      if (!this.userInfo || !this.userInfo.votes || !this.poll) return null;
      const vote = this.userInfo.votes.find(v => v.poll_id === this.poll.poll_id);
      return vote ? vote.candidate_id : null;
    },

    hasVoted() {
      return !!this.userVote;
    },
  },

  methods: {
    formatDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
    },

    getCandidateName(poll, candidateId) {
      if (!poll) return '';
      const c = poll.candidates.find(c => c.candidate_id === candidateId);
      return c ? c.name : 'Unknown';
    },

    async submitVote() {
      if (!this.selectedCandidate || !this.poll) return;
      this.submitting = true;
      // TODO: Replace with actual vote submission logic (API call)
      // Simulate success
      setTimeout(() => {
        this.$emit('voted', { poll_id: this.poll.poll_id, candidate_id: this.selectedCandidate });
        this.submitting = false;
      }, 1000);
    },
  },

  created() {
    const pollId = this.$route.params.poll_id;
    const poll = this.polls.find(p => p.poll_id == pollId);
    console.log('Poll ID:', pollId);
    console.log('Poll data:', poll);
    if (poll) {
      this.poll = poll;
      // Pre-select candidate if user has voted
      const vote = this.userInfo && this.userInfo.votes ? this.userInfo.votes.find(v => v.poll_id == poll.poll_id) : null;
      if (vote) {
        this.selectedCandidate = vote.candidate_id;
      }
    } else {
      this.$router.push('/dashboard/member/polls');
    }
  },
};
</script>
<style scoped>
.poll-card {
  transition: box-shadow 0.2s, transform 0.2s;
  cursor: pointer;
  background: #23272f;
  color: #fff;
  border-radius: 16px;
  margin-bottom: 24px;
}

.poll-card:hover {
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
  transform: translateY(-2px) scale(1.01);
}

.poll-card-centered {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
  min-height: 270px;
}

.poll-card-title-centered {
  width: 100%;
  justify-content: center;
  display: flex;
  font-size: 1.35rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #fff;
}

.poll-card-subtitle-centered {
  width: 100%;
  justify-content: center;
  display: flex;
  color: #b0b8c1;
  font-size: 1rem;
  margin-bottom: 8px;
}

.poll-card-text-centered {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
}

.poll-card-desc-centered {
  color: #e0e0e0;
  font-size: 1.08rem;
  margin-bottom: 10px;
  width: 100%;
}

.poll-card-candidates-centered {
  justify-content: center;
}

.poll-card-actions-centered {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.candidates-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 8px;
}

.candidate-radio {
  margin-bottom: 4px;
}

.v-card-title,
.v-card-subtitle {
  color: #fff;
}

.v-card-actions {
  justify-content: flex-end;
}
</style>
